import { Typography, Badge, Progress, Skeleton, Button, Popconfirm } from "antd";
import { SidePanel } from "../../Shared/Components/SidePanel";
import { renderPercentage, measuringStatusTitles } from "../../../utils";
import { api } from "../../../config";
import { useQuery, useQueryClient } from "react-query";
import { useEffect, useState } from "react";

import { useSelector } from "react-redux";
import { AuthenticationState } from "../../../interfaces/users";
import TicketMeasure from "../../Measuring/TicketModal/TicketMeasure";
import { toast } from "react-toastify";
import { format } from "date-fns";

const { Title } = Typography;

function ModalContainer({ ticketId }: any) {
  const { token } = useSelector((state: AuthenticationState) => state);
  const queryClient = useQueryClient();
  const { isFetching, data, isError, refetch }: any = useQuery(
    ["tickets/measuring"],
    () => api(token).get(`ticket/measuring/${ticketId}`)
  );
  const [editTicketId, setEditTicketId] = useState(false);
  const [formTicketId, setFormTicketId] = useState<number | undefined>(
    undefined
  );

  useEffect(() => {
    if (data?.ticketId) {
      setFormTicketId(data.ticketId);
    }
    setEditTicketId(false);
  }, [data, ticketId]);

  const handleEditTicketIdToggle = () => {
    setEditTicketId(!editTicketId);
  };

  const handleSubmitTicketIdChange = async () => {
    try {
      if (!formTicketId) return toast.error("Id inválido");
      await api(token).put(`/ticket/measuring/${ticketId}`, {
        ticketId: formTicketId,
      });
      handleEditTicketIdToggle();
      refetch();
      toast.success("Relatório vinculado com sucesso!");
    } catch (error) {
      toast.error("Ocorreu um erro ao vincular o ID do ticket");
    }
  };

  const handleDeleteMinhaVisitaClientName = async () => {
    try {
      if (!data.ticket?.id) return;
      await api(token).put(`ticket/checklist/${data.ticket.id}`, {
        minhaVisitaClientName: null,
      });
      refetch();
      queryClient.invalidateQueries(["tickets/measuring/board"]);
      toast.success("Nome do Cliente no Minha Visita apagado com sucesso");
    } catch (error) {
      toast.error("Ocorreu um erro ao apagar o nome do Minha Visita");
    }
  };

  useEffect(() => {
    if (!isError) {
      refetch();
    }
  }, [isError, refetch, ticketId]);

  if (isFetching) return <Skeleton active />;
  if (isError)
    return (
      <>
        <Title className=" border-b-2  border-slate-100 pb-1 ">
          Erro durante o processo de buscar ticket
        </Title>
      </>
    );

  return (
    <>
      <Badge.Ribbon
        className="px-8 mt-12 mx-2"
        text={measuringStatusTitles[data?.status ?? 1]}
        color={data?.status === 5 ? "red" : "blue"}
      />
      {data?.newMeasuringReason && (
        <div className="mb-3 rounded bg-orange-500 px-5 py-2 text-sm font-semibold text-white shadow">
          Nova Medição Solicitada: {data.newMeasuringReason}
        </div>
      )}
      <div className="flex justify-between">
        <Title className=" border-b-2 border-slate-100 pb-1 flex items-center gap-3">
          <span>{data.title}</span>
          {data.ticket?.minhaVisitaClientName && (
            <>
              <span
                className={
                  "flex justify-center bg-green-500 w-fit rounded-full text-white px-5 py-1 text-xs shadow-md my-1"
                }
              >
                Medidas no Minha Visita
              </span>
              <Popconfirm
                title="Apagar nome?"
                description="O nome do Cliente no Minha Visita será removido."
                okText="Apagar"
                cancelText="Cancelar"
                onConfirm={handleDeleteMinhaVisitaClientName}
              >
                <Button size="small" danger>
                  Apagar Nome
                </Button>
              </Popconfirm>
            </>
          )}
        </Title>

        <div className="mr-52 flex gap-1 items-center justify-center">
          {!!data.ticket?.events?.[0]?.start && (
            <p><b>Data Checklist: </b> {format(new Date(data.ticket?.events?.[0]?.start), 'dd/MM/yyyy')}</p>
          )}
          <p><b>Data Checklist </b></p>
          <p className="font-bold">Ticket Checklist: </p>
          {editTicketId ? (
            <input
              value={formTicketId}
              onChange={(e) =>
                setFormTicketId(Number(e.target.value.replace(/\D+/g, "")))
              }
              className="h-6 mr-1 w-10"
              type="text"
            />
          ) : (
            <p> {data.ticketId}</p>
          )}
          <Button
            onClick={
              editTicketId
                ? handleSubmitTicketIdChange
                : handleEditTicketIdToggle
            }
          >
            {editTicketId ? "Salvar" : "Editar"}
          </Button>
        </div>
      </div>
      <div className="flex">
        <div className="w-1/5">
          <SidePanel
            status={data?.status}
            ticketId={data.id}
            type="measuring"
            ownerId={data.ownerId}
          />
        </div>
        <div className="w-4/5 h-[60vh] overflow-y-scroll">
          <TicketMeasure ticket={data} />
        </div>
      </div>
      <div className="w-11/12 absolute bottom-3">
        <div className="w-full flex justify-center items-center">
          <p className="mr-5">Progresso:</p>
          <Progress
            className="mt-2"
            status={
              data?.status === 5 || data?.status === 6 ? "exception" : "active"
            }
            percent={renderPercentage(data?.status)}
          />
        </div>
      </div>
    </>
  );
}

export default ModalContainer;
